const catalogItems = document.querySelectorAll(".catalog__chooser--item");
const catalogHeader = document.querySelector("[data-catalog-header-selected]");
const schoolsSelected = document.querySelectorAll(".catalog__chooser--checkbox");
const schoolsSummaryList = document.querySelector(".catalog__summary--list");
const schoolsSummaryWrapper = document.querySelector(".catalog__summary--wrapper");
const schoolsListWrapper = document.querySelector("[data-list-wrapper]");
const schoolsListSizeToggle = document.querySelector("[data-list-size-toggle]");
const schoolsListSizeClose = document.querySelector("[data-list-size-close]");
const schoolsListSizeNormal = document.querySelector("[data-list-size-normal]");
const schoolsListSizeFyllscreen = document.querySelector("[data-list-size-fullscreen]");
const schoolsListModal = document.querySelector("[data-modal-catalog]");
const schoolsListModalButton = document.querySelector("[data-modal-catalog-button]");
const formSubmitButton = document.querySelector("[data-form-button]");
let checkedCount = 0;

if (schoolsListModalButton && schoolsListModal) {
    schoolsListModalButton.addEventListener("click", ()=>{
        schoolsListModal.classList.remove("active");
    });
}

if(schoolsListWrapper && schoolsListSizeClose && schoolsListSizeNormal && schoolsListSizeFyllscreen){
    schoolsListSizeClose.addEventListener("click", ()=>{
        schoolsListWrapper.classList.remove("catalog__chooser--wrapper-normal","catalog__chooser--wrapper-fullscreen");
    });
    schoolsListSizeNormal.addEventListener("click", ()=>{
        schoolsListWrapper.classList.remove("catalog__chooser--wrapper-fullscreen");
        schoolsListWrapper.classList.add("catalog__chooser--wrapper-normal");
    });
    schoolsListSizeFyllscreen.addEventListener("click", ()=>{
        schoolsListWrapper.classList.remove("catalog__chooser--wrapper-normal");
        schoolsListWrapper.classList.add("catalog__chooser--wrapper-fullscreen");
    });
    schoolsListSizeToggle.addEventListener("click", ()=>{
        schoolsListWrapper.classList.toggle("catalog__chooser--wrapper-normal");
    });
}

function listSelectedSchools(){
    let checkedSchools = [];
    checkedCount = 0;
    let countString = "";
    Array.prototype.forEach.call(schoolsSelected, element =>{
        if(element.checked){
            checkedCount++;
            let school = [];
            school.name = element.parentNode.childNodes[1].innerHTML;
            school.id = element.parentNode.childNodes[0].id;
            checkedSchools.push(school);
        }
    });
    if(checkedCount == 0){
        countString = "Velg skole(r)";
    } else if (checkedCount == 1) {
        countString = "1 skole valgt";
    } else {
        countString = checkedCount + " skoler valgt";
    }
    catalogHeader.innerHTML = countString;

    schoolsSummaryList.innerHTML = "";
    if(checkedSchools.length > 0){
        schoolsSummaryWrapper.classList.add("is-active");
        checkedSchools.forEach(element => {
            var schoolItem = document.createElement("li");
            schoolItem.innerHTML = element.name;
            schoolItem.classList.add("catalog__summary--item");
            var removeSchoolItem = document.createElement("span");
            removeSchoolItem.innerHTML = "fjern";
            removeSchoolItem.classList.add("catalog__summary--remove");
            removeSchoolItem.setAttribute("data-uncheck-school", element.id);
            schoolItem.appendChild(removeSchoolItem);
            schoolsSummaryList.appendChild(schoolItem);
        });
    }
    else {
        schoolsSummaryWrapper.classList.remove("is-active");
    }
    let schoolsSummaryRemove = document.querySelectorAll(".catalog__summary--remove");
    schoolsSummaryRemove.forEach(element => {
        const checkboxVal = element.getAttribute("data-uncheck-school");
        const checkboxObject = document.getElementById(checkboxVal);
        element.addEventListener("click", (click => {
            checkboxObject.checked = false;
            listSelectedSchools();
        }))
    });
}



if(catalogItems.length && catalogHeader){
    catalogItems.forEach(element => {
        element.addEventListener("click", (click => {
            let checkbox = element.childNodes[0];
            if (checkbox.disabled) {
                return;
            }
            click.preventDefault();
            if (checkbox.checked){
                checkbox.checked = false;
                element.checked = false;
            } else {
                if(checkedCount<10){
                    checkbox.checked = true;
                    element.checked = true;
                } else {
                    if (schoolsListModal) {
                        schoolsListModal.classList.add("active");
                    }
                }
            }
            listSelectedSchools();
        }));
        let externalLink = element.querySelector('a');
        if (externalLink) {
            externalLink.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }
    });

    window.addEventListener('load', () => {
        listSelectedSchools();
    });
}

const formZipField = document.querySelector('[data-form-zip]');
const formCityField = document.querySelector('[data-form-city]');
if (formZipField && formCityField) {
    formZipField.addEventListener('input', function() {
        const zipCode = this.value;

        if (zipCode.length != 4) return;

        fetch(`/xhr/v1/frontend/zip?zip=${zipCode}`)
        .then(response => response.json())
        .then(data => {
            this.fetchingCityName = false;
            if (!data.postal_codes) {
                return;
            }

            formCityField.value = data.postal_codes[0].city;
        });
    });
}

if (formSubmitButton) {
    formSubmitButton.addEventListener("click", function(event) {
        event.preventDefault();
        let form = document.querySelector(".catalog__form");
        let formFields = form.querySelectorAll("input[type='text'], input[type='tel'], select[data-form-country]");
        let nrOfErrors = 0;
        let errorField = null;
        for (let i = 0; i < formFields.length; i++){
            if (!formFields[i].required) {
                continue;
            }
            let errorMessageField = formFields[i].closest('.catalog__form--item').querySelector(".catalog__form--errormsg");
            if (formFields[i].value == "") {
                nrOfErrors++;
                if(errorField == null){
                    errorField = formFields[i];
                }
                formFields[i].classList.add("catalog__form--field--error");
                errorMessageField.classList.add("active");
                formFields[i].setAttribute("aria-invalid", "true");
                formFields[i].setAttribute("aria-describedby", errorMessageField.id);
            } else {
                formFields[i].classList.remove("catalog__form--field--error");
                errorMessageField.classList.remove("active");
                formFields[i].setAttribute("aria-invalid", "false");
                formFields[i].removeAttribute("aria-describedby");
            }
        }
        if (errorField) {
            errorField.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
        if (!nrOfErrors) {
            form.submit();
        }
    });
}
